import { render, staticRenderFns } from "./contacts-swiper.vue?vue&type=template&id=38cd04d4&"
import script from "./contacts-swiper.vue?vue&type=script&lang=js&"
export * from "./contacts-swiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports